import { Layout, Text } from '@loadsmart/miranda-react'

import emptyTenderOfferImage from '../assets/empty-tender-offer.svg'

export function EmptyState() {
  return (
    <Layout.Stack gap="spacing-4" align="center">
      <img src={emptyTenderOfferImage} alt="Empty tender offer" width={322} />
      <Layout.Stack gap="spacing-1" align="center">
        <Text variant="heading-lg-bold" style={{ textAlign: 'center' }}>
          Ready to win more business
        </Text>
        <Text variant="body-lg" color="color-text-secondary" style={{ textAlign: 'center' }}>
          You don't have any active tender invitations at the moment,
          <br /> when shippers invite you they'll appear here
        </Text>
      </Layout.Stack>
    </Layout.Stack>
  )
}
